"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Utils = require("player-core/utils");
require("./Checkbox.css");
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this._onClick = _this._onClick.bind(_this);
        _this._getAccessibility = _this._getAccessibility.bind(_this);
        _this._getCheckmarkCSS = _this._getCheckmarkCSS.bind(_this);
        _this._getLabelCSS = _this._getLabelCSS.bind(_this);
        _this._id = _this.props.id ? _this.props.id : 'inp' + Utils.createUUID();
        return _this;
    }
    Checkbox.prototype._onClick = function (event, id) {
        var _a = this.props, onChange = _a.onChange, isChecked = _a.isChecked;
        var onChangeFunc = onChange || null;
        var value = !isChecked;
        if (onChangeFunc) {
            onChangeFunc(value, id);
        }
    };
    Checkbox.prototype._getAccessibility = function () {
        var _a = this.props, isEnabled = _a.isEnabled, showLabel = _a.showLabel, ariaLabeledBy = _a.ariaLabeledBy, label = _a.label, isRequired = _a.isRequired, errorMessage = _a.errorMessage;
        var labelText = label || '';
        var haslabel = labelText.length > 0;
        var accessibilityAttrInput = {};
        if (!isEnabled) {
            accessibilityAttrInput['aria-disabled'] = true;
        }
        if (isRequired) {
            accessibilityAttrInput['aria-required'] = true;
        }
        if (errorMessage) {
            accessibilityAttrInput['aria-invalid'] = true;
        }
        if (!showLabel) {
            accessibilityAttrInput['aria-label'] = labelText;
        }
        if (!haslabel) {
            accessibilityAttrInput['aria-labelledby'] = ariaLabeledBy;
        }
        return accessibilityAttrInput;
    };
    Checkbox.prototype._getCheckmarkCSS = function () {
        var _a = this.props, isChecked = _a.isChecked, isEnabled = _a.isEnabled, errorMessage = _a.errorMessage;
        var checkmarkCSS = 'checkbox-indicator';
        if (isChecked) {
            checkmarkCSS += ' p-icon-check p-bg-primary50 p-bc-primary30 p-t-on-primary50';
            if (isEnabled) {
                checkmarkCSS += ' p-bg-hv-primary50';
            }
        }
        else {
            checkmarkCSS += ' p-bg-grey80 p-bc-grey40';
            if (isEnabled) {
                checkmarkCSS += ' p-bg-hv-grey70';
            }
        }
        if (errorMessage) {
            checkmarkCSS += ' p-b-error p-bc-error50';
        }
        return checkmarkCSS;
    };
    Checkbox.prototype._getLabelCSS = function () {
        var _a = this.props, isEnabled = _a.isEnabled, isRequired = _a.isRequired, errorMessage = _a.errorMessage;
        var labelCSS = 'p-checkbox';
        if (isEnabled) {
            labelCSS += ' enabled';
        }
        else {
            labelCSS += ' disabled';
        }
        if (isRequired) {
            labelCSS += ' is-required';
        }
        if (errorMessage) {
            labelCSS += ' is-invalid';
        }
        return labelCSS;
    };
    Checkbox.prototype.componentWillReceiveProps = function (props) {
        if (this.props.id !== props.id) {
            this._id = props.id;
        }
    };
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, tag = _a.tag, isEnabled = _a.isEnabled, showLabel = _a.showLabel, isChecked = _a.isChecked, label = _a.label, description = _a.description, errorMessage = _a.errorMessage, isRequired = _a.isRequired;
        var accessibility = this._getAccessibility();
        var checkmarkCSS = this._getCheckmarkCSS();
        var labelCSS = this._getLabelCSS();
        return (React.createElement("div", { "data-tag": tag },
            React.createElement("div", null,
                React.createElement("label", { htmlFor: this._id, className: labelCSS },
                    showLabel &&
                        React.createElement("span", { className: "checkbox-label" }, label),
                    isRequired &&
                        React.createElement("span", { className: "p-t-error50" }, "*"),
                    React.createElement("input", __assign({ type: "checkbox", id: this._id, disabled: !isEnabled, required: isRequired, onClick: function (e) { return _this._onClick(e, _this._id); }, "aria-checked": isChecked, readOnly: true }, accessibility, { checked: isChecked })),
                    React.createElement("div", { className: checkmarkCSS, "aria-hidden": "true" }))),
            (description || errorMessage) &&
                React.createElement("div", null,
                    description &&
                        React.createElement("p", { className: "note" }, description),
                    errorMessage ?
                        React.createElement("p", { className: "error p-t-error50" }, errorMessage) :
                        null)));
    };
    return Checkbox;
}(React.Component));
Checkbox.defaultProps = {
    label: '',
    tag: null,
    isChecked: false,
    isEnabled: true,
    ariaLabeledBy: '',
    onChange: void (0),
    id: '',
    isRequired: false,
    errorMessage: '',
    description: ''
};
exports.Checkbox = Checkbox;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['editor-controls'])
        csod.engine.controls['editor-controls'] = {};
    csod.engine.controls['editor-controls']['Checkbox'] = Checkbox;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Checkbox"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-editor-controls/controls/Checkbox/index.js
// module id = 152
// module chunks = 0 1